"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsConstants = void 0;
var AnalyticsConstants = /** @class */ (function () {
    function AnalyticsConstants() {
    }
    AnalyticsConstants.DiagnosticsEventTypes = {
        DEBUG: 'DEBUG',
        ERROR: 'ERROR',
        INFO: 'INFO',
        WARN: 'WARN',
    };
    AnalyticsConstants.Events = {
        APP_ENTRY_EVENT: 'appEntryEvent',
        APP_ERROR: 'appError',
        APP_EXIT_EVENT: 'appExitEvent',
        APPLICATION_START: 'applicationStart',
        AUTHENTICATION_CONFIGURATION_SUCCESSFUL: 'authenticationConfigurationSuccessful',
        CANCEL_SIGN_IN: 'cancelSignIn',
        CLEAR_SAVED_SIGN_IN_DATA: 'clearSavedSignInData',
        CONTENT_VIEW: 'contentView',
        DEEP_LINK_ERROR: 'deepLinkError',
        DEVICE_INFO: 'deviceInfo',
        DEVICE_SETTINGS: 'deviceSettings',
        DO_SIGNIN_RETRY: 'doSigninRetry',
        ERROR_EVENT: 'errorEvent',
        FAILURE_LOADING_CHANNELS: 'failureLoadingChannels',
        FAILURE_LOADING_GUIDE_ROWS: 'failureLoadingGuideRows',
        FAILURE_LOADING_PREVIEW: 'failureLoadingPreview',
        FINISH_LOADING_CHANNELS: 'finishLoadingChannels',
        FINISH_LOADING_GUIDE: 'finishLoadingGuide',
        FINISH_LOADING_GUIDE_ROWS: 'finishLoadingGuideRows',
        FINISH_LOADING_PREVIEW: 'finishLoadingPreview',
        FIRST_FRAME: 'firstFrame',
        HANDLE_LOGIN_FAIL: 'handleLoginFail',
        HEART_BEAT: 'heartBeat',
        IDENTIFY: 'identify',
        ITEM_SELECTED_EVENT: 'itemSelectedEvent',
        KEY_EVENT: 'keyEvent',
        LOGIN_EVENT: 'loginEvent',
        LOGIN_FAILURE_EVENT: 'loginFailureEvent',
        LOGIN_WITH_SAVED_SAML_TKN: 'loginWithSavedSamlTkn',
        LOGOUT_EVENT: 'logoutEvent',
        MEDIA_HEALTH: 'mediaHealth',
        MENU_ITEM_SELECTED_EVENT: 'menuItemSelectedEvent',
        MILESTONE_REACHED_EVENT: 'milestoneReachedEvent',
        NET_INFO: 'netInfo',
        NOTIFY_EVENT: 'notifyEvent',
        ON_SIGN_IN_QUERY_ERROR: 'onSignInQueryError',
        ON_SIGN_IN_QUERY_RESPONSE: 'onSignInQueryResponse',
        ON_SIGN_OUT_DONE: 'onSignOutDone',
        RECONNECT: 'reconnect',
        SCREEN: 'screen',
        SESSION_CREATED: 'sessionCreated',
        SIGN_IN_ERROR: 'signInError',
        SIGN_IN_FAILED: 'signInFailed',
        SIGN_OUT_DONE: 'signOutDone',
        SIGN_OUT: 'signOut',
        START_LOADING_CHANNELS: 'startLoadingChannels',
        START_LOADING_GUIDE: 'startLoadingGuide',
        START_LOADING_GUIDE_ROWS: 'startLoadingGuideRows',
        START_LOADING_PREVIEW: 'startLoadingPreview',
        START_SIGNIN_RETRY: 'startSigninRetry',
        STREAMING_END: 'streamingEnd',
        STREAMING_RECOVERY: 'streamingRecovery',
        STREAMING_START: 'streamingStart',
        SYSTEM_MEMORY_INFO: 'systemMemoryInfo',
        TIVO_APP_START: 'tivoAppStart',
        TRICK_PLAY_EVENT: 'trickPlayEvent',
        USER_ACTION_EVENT: 'userActionEvent',
        USER_AGREEMENT: 'userAgreement',
        VIDEO_PLAYER_OPEN_STREAM: 'videoPlayerOpenStream',
        WATCH_CONTENT_END: 'watchContentEnd',
        WATCH_CONTENT_START: 'watchContentStart',
        WATCH_STARTED_EVENT: 'watchStartedEvent',
        WATCH_STOPPED_EVENT: 'watchStoppedEvent',
        WELCOME_SCREEN: 'welcomeScreen',
    };
    AnalyticsConstants.Screens = {
        GUIDE_SCREEN: 'guideScreen',
        LIVE_TV_SCREEN: 'liveTvScreen',
        SETTINGS_SCREEN: 'settingsScreen',
        WELCOME_SCREEN: 'welcomeScreen',
    };
    AnalyticsConstants.TransitionState = {
        ENTER: 'enter',
        EXIT: 'exit',
        RESUME: 'resume',
        SUSPEND: 'suspend',
    };
    AnalyticsConstants.Fields = {
        DEVICE_LOG_LEVEL: 'deviceLogLevel',
        ERROR_CODE: 'errorCode',
        EVENT_NAME: 'event_name',
        EVENT_TYPE: 'event_type',
        LAUNCH_POINT_NAME: 'launchPointName',
        LAUNCH_POINT_TYPE: 'launchPointType',
        LOG_TYPE: 'logType',
        MESSAGE: 'message',
        REFRENCE_TIME: 'refrenceTime',
        SCREEN_NAME: 'screenName',
        SCREEN_TITLE: 'screenTitle',
        SCREEN_TRANSITION: 'screenTransition',
        TIME_SPENT_ON_SCREEN: 'timeSpentOnScreen',
    };
    AnalyticsConstants.LogTypes = {
        DIAGNOSTICS: 'diagnostics',
        OPERATIONS: 'operations',
    };
    AnalyticsConstants.SegmentEvents = {
        ALIAS: 'alias',
        FLUSH: 'flush',
        GROUP: 'group',
        IDENTIFY: 'identify',
        PAGE: 'page',
        SCREEN: 'screen',
        TRACK: 'track',
    };
    return AnalyticsConstants;
}());
exports.AnalyticsConstants = AnalyticsConstants;
